export default __webpack_public_path__ + "static/media/favicon.8ffc3d0b.ico";